import {
  ProgressionsNameMapping,
  ProgressionStepsNameMapping,
} from '@/features/inventory/inventory-item-display'
import type {
  JobProgressionFlow,
  JobProgressionStepStatus,
} from '@/features/jobs/taxes/progression/JobProgression'

export type AllowedProgressionTypes = Extract<
  JobProgressionFlow,
  'Outsourcing' | 'Retail' | 'Essential' | 'Preparation' | 'Review'
>

export type AllowedProgressionSteps = Extract<
  JobProgressionStepStatus,
  | 'JobStarted'
  | 'OpenItems'
  | 'DraftInReview'
  | 'DraftRejected'
  | 'DraftApproved'
  | 'AuthorizationSigned'
  | 'ReturnFiled'
  | 'DeliverableCompleted'
  | 'PreparationCompleted'
  | 'ReviewCompleted'
>

export interface AvailableProgressionOption {
  name: string
  value: AllowedProgressionTypes
}

export interface AvailableProgressionStep {
  name: string
  value: AllowedProgressionSteps
}

export const AvailableProgressions: AvailableProgressionOption[] = [
  {
    name: ProgressionsNameMapping.Outsourcing,
    value: 'Outsourcing',
  },
  {
    name: ProgressionsNameMapping.Essential,
    value: 'Essential',
  },
  {
    name: ProgressionsNameMapping.Review,
    value: 'Review',
  },
  {
    name: ProgressionsNameMapping.Retail,
    value: 'Retail',
  },
  {
    name: ProgressionsNameMapping.Preparation,
    value: 'Preparation',
  },
]

export const AvailableProgressionSteps: Record<
  AllowedProgressionTypes,
  AvailableProgressionStep[]
> = {
  Outsourcing: progressionSteps(
    'JobStarted',
    'OpenItems',
    'DraftApproved',
    'DraftInReview',
    'DraftRejected',
  ),
  Essential: progressionSteps('JobStarted', 'DeliverableCompleted'),
  Preparation: progressionSteps(
    'JobStarted',
    'OpenItems',
    'PreparationCompleted',
  ),
  Retail: progressionSteps(
    'JobStarted',
    'OpenItems',
    'DraftApproved',
    'DraftInReview',
    'DraftRejected',
    'AuthorizationSigned',
    'ReturnFiled',
  ),
  Review: progressionSteps(
    'JobStarted',
    'OpenItems',
    'DraftApproved',
    'DraftInReview',
    'DraftRejected',
    'ReviewCompleted',
  ),
}

function progressionSteps(
  ...values: AllowedProgressionSteps[]
): AvailableProgressionStep[] {
  return values.map((value) => ({
    name: ProgressionStepsNameMapping[value],
    value,
  }))
}
